export default (array, key) =>
    Array.from(
        array
            .reduce((map, obj) => {
                map.set(obj[key], obj);
                return map;
            }, new Map())
            .values()
    );
